import { queryOptions } from "@tanstack/react-query";

import { getCountries } from "@/generated/api/users";

const countriesQuery = () =>
  queryOptions({
    queryFn: ({ signal }) => getCountries({ signal }),
    queryKey: ["countries"],
    staleTime: Infinity,
  });

export { countriesQuery };
